import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { services, additionalServices } from '../data/content';
import { NavLink } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import { FiCheck, FiArrowRight } from 'react-icons/fi';

const Services = () => {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const element = document.getElementById(hash.replace('#', ''));
      if (element) element.scrollIntoView({ behavior: 'smooth' });
    }
  }, [hash]);

  return (
    <div className="pt-0 pb-32 bg-white">
      {/* Hero */}
      <div className="bg-brand-gradient text-white py-24 lg:py-32 mb-24 text-center relative overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 relative z-10">
          <span className="text-ms-red font-black uppercase tracking-[0.4em] text-sm mb-4 block">Portfolio</span>
          <h1 className="text-5xl lg:text-7xl font-black mb-8 uppercase tracking-tighter">Unsere Leistungen</h1>
          <p className="text-xl text-white/80 max-w-3xl mx-auto font-medium">
            Individuelle Lösungen für Ihren Außenbereich – von der Terrassenüberdachung bis zum Wintergarten.
          </p>
        </div>
      </div>

      {/* Detailed Services */}
      <div className="max-w-7xl mx-auto px-4 space-y-40">
        {services.map((service, index) => (
          <div key={service.id} id={service.id} className={`flex flex-col lg:flex-row gap-20 items-center ${index % 2 === 1 ? 'lg:flex-row-reverse' : ''}`}>
            <div className="flex-1">
              <div className="w-20 h-20 bg-ms-light rounded-[2rem] flex items-center justify-center mb-8 text-ms-blue text-4xl shadow-inner">
                <SafeIcon icon={service.icon} />
              </div>
              <h2 className="text-4xl font-black text-ms-dark mb-8 uppercase tracking-tighter border-l-8 border-ms-blue pl-6">
                {service.title}
              </h2>
              <p className="text-lg text-ms-dark/70 mb-10 leading-relaxed font-medium">
                {service.details}
              </p>
              
              <div className="bg-ms-light p-8 rounded-[2rem] mb-10 border border-ms-blue/5">
                <h4 className="font-black text-ms-dark mb-6 uppercase tracking-widest text-sm flex items-center">
                  <span className="w-8 h-1 bg-ms-red mr-3"></span> Vorteile
                </h4>
                <ul className="grid sm:grid-cols-2 gap-y-4 gap-x-8">
                  {service.features.map((feature, i) => (
                    <li key={i} className="flex items-center text-ms-dark font-bold text-sm uppercase tracking-tight">
                      <SafeIcon icon={FiCheck} className="text-ms-blue mr-3 text-xl flex-shrink-0" />
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>

              <NavLink to="/kontakt" className="inline-flex items-center bg-ms-solar text-white px-8 py-4 rounded-2xl font-black hover:bg-ms-blue transition shadow-xl uppercase tracking-tighter">
                Details anfragen <SafeIcon icon={FiArrowRight} className="ml-3" />
              </NavLink>
            </div>
            
            <div className="flex-1 w-full bg-ms-light rounded-[3rem] h-[500px] flex items-center justify-center border-4 border-white shadow-2xl">
              {/* Placeholder für Projektbilder */}
              <div className="text-center p-12">
                <SafeIcon icon={service.icon} className="text-8xl text-ms-blue/20 mx-auto mb-6" />
                <p className="text-ms-dark/30 font-black uppercase tracking-widest text-sm">Projekt-Visualisierung {service.title}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Additional Service Info */}
      <div className="bg-ms-light py-32 mt-40">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <h2 className="text-4xl font-black text-ms-dark uppercase tracking-tighter mb-16">Rundum-Sorglos-Service</h2>
          <div className="grid md:grid-cols-3 gap-10">
            {additionalServices.map((s, i) => (
              <div key={i} className="bg-white p-10 rounded-[3rem] shadow-xl">
                <div className="w-16 h-16 bg-ms-blue/10 rounded-2xl flex items-center justify-center text-ms-blue text-2xl mx-auto mb-6">
                  <SafeIcon icon={s.icon} />
                </div>
                <h3 className="text-xl font-black text-ms-dark uppercase tracking-tighter mb-4">{s.title}</h3>
                <p className="text-ms-dark/60 font-bold text-sm uppercase leading-relaxed">{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;